import { Component, ElementRef, AfterViewInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { HttpUtilService } from "src/app/services/http-util.service";
import { GlobalConstants } from "src/app/shared/global-constants";

declare global {
  interface Window {
    captchaloaded: () => void;
    grecaptcha: any;
  }
}

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.scss"],
})
export class ForgotPasswordComponent implements AfterViewInit {
  sending = false;
  verified = false;
  captcha = "";
  sent = false;
  serviceError = false;
  serviceErrorMessage = "";
  resetPass$: Subscription;
  forgotForm: FormGroup<{
    email: FormControl<string | null>
  }>;
  @ViewChild("recaptcha") recaptchaElement: ElementRef;

  constructor(private httpUtil: HttpUtilService, private router: Router) {
    this.forgotForm = new FormGroup({
      email: new FormControl("", [Validators.email, Validators.required]),
    });
  }

  ngAfterViewInit() {
    this.addRecaptchaScript();
  
  }

  get email() {
    return this.forgotForm.get("email");
  }

  renderReCaptch() {
    window["grecaptcha"].render(this.recaptchaElement.nativeElement, {
      sitekey: GlobalConstants.CAPTCHA_SITE_KEY,
      callback: (response) => {
        this.verified = true;
        this.captcha = response;
      },
      'expired-callback': () => {
        this.verified = false;
        this.captcha = '';
      }
    });
  }

  addRecaptchaScript() {
    window["grecaptchaCallback"] = () => {
      this.renderReCaptch();
    };

    const id = "recaptcha-jssdk";
    let js: HTMLScriptElement;
    const fjs = document.getElementsByTagName("script")[0];
    if (fjs) {
      if (document.getElementById(id)) {
        this.renderReCaptch();
        return;
      }
      js = document.createElement("script");
      js.id = id;
      js.src =
        "https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&render=explicit";
      fjs.parentNode.insertBefore(js, fjs);
    }
  }

  submit() {
    this.sending = true;
    this.resetPass$ = this.httpUtil
      .callService({
        serviceName: "portal.resetPassword",
        payload: {
          resetPasswordServiceRq: {
            userId: this.email.value,
            "g-recaptcha-response": this.captcha,
          },
        },
      })
      .subscribe((res) => {
        this.sending = false;
        if (
          res.resetPasswordServiceRs &&
          res.resetPasswordServiceRs.status === "error"
        ) {
          this.serviceError = true;
          this.serviceErrorMessage = res.resetPasswordServiceRs.message;
        } else {
          this.sent = true;
          setTimeout(() => {
            this.router.navigate(["/login"]);
          }, 4000)
        }
      });
  }

  isValid(): boolean {
    return this.forgotForm.valid && this.verified;
  }
}
